import { render, staticRenderFns } from "./MachineBrand.vue?vue&type=template&id=f9225c7e&"
import script from "./MachineBrand.vue?vue&type=script&lang=js&"
export * from "./MachineBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports